import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { SITE_EMAIL } from "@/utils/format";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/about", label: "关于我们" },
  { to: "/about#values", label: "内容原则" },
  { to: "/#faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-line text-2xl" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-background-50">
                瓜友会网
              </span>
            </div>
            <p className="text-sm text-primary-100/80 leading-relaxed">
              一手热瓜实时更新。从娱乐圈到网红圈，把散落的线索整理成清晰的时间线，
              蹲最新进展、看网友热评，就在吃瓜现场。
            </p>
            <div className="flex items-center gap-2 mt-5">
              <a
                href={`mailto:${SITE_EMAIL}`}
                aria-label="发送邮件到瓜友会网"
                className="w-9 h-9 rounded-md bg-primary-800 hover:bg-primary-700 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
              <Link
                to="/about#submit"
                aria-label="前往爆料投稿"
                className="w-9 h-9 rounded-md bg-primary-800 hover:bg-primary-700 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-megaphone-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/#faq"
                aria-label="查看常见问题"
                className="w-9 h-9 rounded-md bg-primary-800 hover:bg-primary-700 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-question-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <nav aria-label="热门瓜田">
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门瓜田
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-primary-100/80 hover:text-background-50 transition-colors cursor-pointer inline-flex items-center gap-2"
                  >
                    <i className={cat.icon} aria-hidden="true"></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站内导航">
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              站内导航
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-primary-100/80 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系与投稿
            </h4>
            <p className="text-sm text-primary-100/80 leading-relaxed mb-3">
              有想分享的线索？欢迎投递给我们，核实后会整理成可读的时间线。
            </p>
            <a
              href={`mailto:${SITE_EMAIL}`}
              className="inline-flex items-center gap-2 text-sm text-background-50 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              {SITE_EMAIL}
            </a>
            <Link
              to="/about#submit"
              className="mt-4 inline-flex items-center gap-1 h-10 px-4 rounded-full bg-accent-500 text-foreground-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-add-line" aria-hidden="true"></i>
              提交爆料线索
            </Link>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-100/60">
            © 2026 瓜友会网 · 内容为公开网络信息的整理与转述，仅供讨论交流，不构成任何事实认定。
          </p>
          <div className="flex items-center gap-4 text-xs text-primary-100/60">
            <Link
              to="/about#values"
              className="hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              内容原则
            </Link>
            <Link
              to="/about"
              className="hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              免责说明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}